export const STORAGE_BOX_ROOT_LABEL = 'Storage Box';
export const STORAGE_BOX_BIN_LABEL = 'Bin';
export const STORAGE_BOX_FAVORITES_LABEL = 'Favorites';
export const STORAGE_BOX_LOCK_LABEL = 'Lock folder';
/** Lock vault status toast (paired with unlock/lock icon). */
export const STORAGE_BOX_LOCK_STATUS_UNLOCKED = 'Lock Folder — Unlocked';
/** Lock vault status toast (paired with unlock/lock icon). */
export const STORAGE_BOX_LOCK_STATUS_LOCKED = 'Lock Folder — Locked';
export const STORAGE_BOX_LOCK_STATUS_LOCKED_IDLE = `${STORAGE_BOX_LOCK_STATUS_LOCKED} (inactivity)`;

export function lockVaultNoticeLabel(variant) {
  if (variant === 'unlocked') return STORAGE_BOX_LOCK_STATUS_UNLOCKED;
  if (variant === 'locked-idle') return STORAGE_BOX_LOCK_STATUS_LOCKED_IDLE;
  return STORAGE_BOX_LOCK_STATUS_LOCKED;
}
export const STORAGE_BOX_SHARED_LABEL = 'Shared with me';
export const STORAGE_BOX_BIN_RETENTION_DAYS = 30;

export const STORAGE_BOX_DEFAULT_VIEW_MODE = 'grid';
export const STORAGE_BOX_DEFAULT_SORT_FIELD = 'name';
export const STORAGE_BOX_DEFAULT_SORT_DIR = 'asc';

export const STORAGE_BOX_SIDEBAR_WIDTH_MIN = 200;
export const STORAGE_BOX_SIDEBAR_WIDTH_MAX = 480;
export const STORAGE_BOX_SIDEBAR_WIDTH_DEFAULT = 264;
export const STORAGE_BOX_SIDEBAR_WIDTH_STORAGE_KEY = 'sb_shell_sidebar_width_v1';

/** Auto-lock Lock folder after idle time (matches server lock session TTL). */
export const STORAGE_BOX_LOCK_VAULT_IDLE_MS = 15 * 60 * 1000;

/** Hex fills for color tags (inline styles — reliable on buttons / dark theme). */
export const STORAGE_BOX_COLOR_HEX = {
  red: '#ea4335',
  orange: '#fa7b17',
  amber: '#fbbc04',
  yellow: '#fdd663',
  green: '#34a853',
  teal: '#12b5cb',
  blue: '#4285f4',
  indigo: '#5c6bc0',
  purple: '#a142f4',
  pink: '#f538a1',
  gray: '#9aa0a6',
};

export const STORAGE_BOX_COLOR_TAGS = [
  { id: '', label: 'No color' },
  { id: 'red', label: 'Red' },
  { id: 'orange', label: 'Orange' },
  { id: 'amber', label: 'Amber' },
  { id: 'yellow', label: 'Yellow' },
  { id: 'green', label: 'Green' },
  { id: 'teal', label: 'Teal' },
  { id: 'blue', label: 'Blue' },
  { id: 'indigo', label: 'Indigo' },
  { id: 'purple', label: 'Purple' },
  { id: 'pink', label: 'Pink' },
  { id: 'gray', label: 'Gray' },
];

/** Default main heading when viewing the StorageBox home folder. */
export function storageBoxHomeTitle(appName = 'Bahlus') {
  const name = String(appName || 'Bahlus').trim() || 'Bahlus';
  return `${name} Storage Box`;
}
